<template>
  <div v-if="load" class="cards-wrap">
    <Title :prev="viewData.prev"
           :secondTitle="title"
           :desc="viewData.desc"
           :titleClass="viewData.titleClass"
           :title="mainTitle"
    />
    <div class="cards bg-gray">
      <div class="cards__inner" :style="cardsWidth">
        <Card v-for="item in data"
              :data="item"
              :img="item.photo"
              :key="item._id"
              :imgClass="viewData.imgClass || 'card__img--small'"
              :designer="viewData.designer"
              :namePage="viewData.namePage"
              :next="next(item.name, item._id)"
              :active="viewData.active"
              :addInfo="viewData.addInfo"
              :hint="viewData.hint"
              @updateData="getData"
        />
        <Plus v-if="viewData.designer === undefined || viewData.designer"
              :namePage="viewData.namePage"
              :plusName="viewData.plusName"
        />
      </div>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>

  import Title from "../components/Title";
  import Card from "../components/Card";
  import Plus from "../components/Plus";
  import Loader from "../components/Loader";
  export default {
    name: "Cards",
    components: {Loader, Plus, Card, Title},
    data() {
      return {
        viewData: {},
        data: {},
        load: false,
        title: '',
        mainTitle: ''
      }
    },
    methods: {
      getData() {
        this.load = false;
        this.data = {};
        this.viewData = this.$store.state[this.$route.meta.viewData[0]][this.$route.meta.viewData[1]];
        this.$store.dispatch(this.viewData.data, this.$route.params)
          .then(res => {
            for (let value of res.body) {
              if (value.photo !== undefined) {
                value.photo = process.env.VUE_APP_URL + value.photo;
              }
            }
            if (this.viewData.designer !== undefined && !this.viewData.designer) {
              for (let i = 0; i < res.body.length; i++) {
                if (res.body[i].status === 'inactive'
                    || this.$route.name === 'check-brands' && res.body[i].models === 0)
                {
                  res.body.splice(i, 1);
                  i--;
                }
              }
            }
            this.data = res.body;
            this.secondTitle();
          });
      },
      getQuestions() {
        this.$store.dispatch('questionsGenerations/QUESTIONS_GENERATIONS', this.$route.params)
          .then(res => {
            let questions = [];
            for (let value of res.body) {
              if (value.answers > 0 && value.status === 'active') {
                questions.push(value._id);
              }
            }
            if (questions.length > 0) {
              this.$store.commit('answers/CHANGE_ANSWERS_DATA', questions);
              this.$router.push({name: 'check-answers', params: {q_id: questions[0]}});
            }
            else {
              let params = {};
              Object.assign(params, this.$route.params);
              params.q_id = 0;
              this.$router.push({name: 'check-end', params: params});
            }
          })
      },
      secondTitle() {
        this.title = '';
        this.mainTitle = '';
        if (this.viewData.secondTitle) {
          if (typeof this.viewData.secondTitle === 'string') {
            this.title = this.viewData.secondTitle;
            this.load = true;
          }
          else {
            this.title += decodeURI(this.$route.params.brand);
            let params = {};
            let paramsNames = ['g_id', 'm_id', 'brand'];
            Object.assign(params, this.$route.params);
            if (this.viewData.secondTitleName !== undefined) {
              for (let i = 0; i < this.viewData.secondTitleName.length; i++) {
                this.title += ' - ';
                for (let j = 0; j < paramsNames.length; j++) {
                  if (params[paramsNames[j]] === undefined) {
                    paramsNames.splice(j, 1);
                    j--;
                  }
                  else {
                    params.id = params[paramsNames[j]];
                    delete params[paramsNames[j]];
                    break;
                  }
                }
                this.$store.dispatch(this.viewData.secondTitleName[i], params)
                  .then(res => {
                    this.title += res.body.name;
                    this.load = true;
                  })
              }
            }
            else {
              this.load = true;
            }
          }
        }
        else {
          if (this.$route.name === 'designer-answers' || this.$route.name === 'check-answers') {
            let params = {};
            Object.assign(params, this.$route.params);
            params.id = params.q_id;
            this.$store.dispatch('questionsGenerations/QUESTION_GENERATIONS', params)
              .then(res => {
                this.mainTitle = res.body.name;
                this.load = true;
              })
          }
          else {
            this.load = true;
          }
        }
      },
      next(name, id) {
        let next;
        if (this.viewData.next !== undefined) {
          next = {
            name: this.viewData.next,
            params: {}
          };
          if (this.viewData.nextName !== undefined) {
            if (this.viewData.namePage === 'brands') {
              next.params[this.viewData.nextName] = name;
            }
            else if (this.$route.name === 'check-answers') {
              for (let i = 0; i < this.$store.state.answers.answersData.length; i++) {
                if (this.$route.params.q_id === this.$store.state.answers.answersData[i]) {
                  if (i !== this.$store.state.answers.answersData.length - 1) {
                    next.params[this.viewData.nextName] = this.$store.state.answers.answersData[i + 1];
                  }
                  else {
                    next.name = 'check-end';
                  }
                  break;
                }
              }
            }
            else {
              next.params[this.viewData.nextName] = id;
            }
          }
        }
        else {
          next = undefined;
        }
        return next;
      }
    },
    computed: {
      cardsWidth() {
        let width = 'max-width: ';
        let plus = 0;
        if (this.viewData.designer || this.viewData.designer === undefined) {
          plus = 1;
        }
        if (this.data.length < 4) {
          width += 268 * (this.data.length + plus) + 'px';
        }
        else {
          width += '100%';
        }
        return width;
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if(vm.$route.name.split('-')[0] === 'check' && vm.$route.name !== 'check-brands' && vm.$store.state.answers.testData.length === 0) {
          vm.$router.push({name: 'check-brands'});
        }
        else {
          vm.getData();
        }
      });
    },
    beforeRouteUpdate(to, from, next) {
      next();
      if (to.name === 'check-questions') {
        this.getQuestions();
      }
      else {
        this.getData();
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .cards {
    display: flex;
    justify-content: center;
    padding: 40px;
    @media (max-width: 767px) {
      width: calc(100% + 30px);
    }
    @media (max-width: 575px) {
      padding: 40px 15px;
    }
    &-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 60px;
      @media (max-width: 575px) {
        margin-bottom: 0;
      }
    }
    &__inner {
      display: flex;
      flex-wrap: wrap;
      width: ($cardWidth + 16px) * 4;
      @media (max-width: 1249px) {
        width: ($cardWidth + 16px) * 3;
      }
      @media (max-width: 991px) {
        width: ($cardWidth + 16px) * 2;
      }
      @media (max-width: 767px) {
        width: calc(100% + 30px);
        max-width: 100% !important;
      }
      @media (max-width: 400px) {
        width: 216px;
      }
    }
  }
</style>